import localStorageIds from '../constants/localStorageIds'
import { USER_ADDONS } from '../constants/userAddons'
import localStorageHelper from './localStorageHelper'

const isUserAddonsValid = (allowedAddons) => {
  const { ALL } = USER_ADDONS
  if (allowedAddons === ALL) return true

  const { localStorageValue: userAddons } = localStorageHelper(localStorageIds.ADDONS)

  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)
  const { id: orgId } = selectedOrg || {}

  if (!userAddons || !selectedOrg) return false
  if (!userAddons[orgId]) return false

  return userAddons[selectedOrg?.id].some((addon) => allowedAddons.includes(addon))
}

export default isUserAddonsValid
